var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.679 8.37912L12.052 7.08546C11.9658 7.06396 11.858 7.06396 11.7716 7.08546L9.72351 7.53829C9.48635 8.01261 9.22768 8.53011 8.96885 9.04743L11.2543 8.53008V18.7709L6.9208 19.7627V12.0659C6.70514 12.1521 6.48964 12.1953 6.25249 12.1953C6.03683 12.1953 5.82134 12.1521 5.62734 12.0874V19.7842L1.29385 18.7924L1.2937 8.53002L3.53583 9.04749L2.78116 7.53836L0.797675 7.08553C0.603673 7.04237 0.409679 7.08553 0.237163 7.21486C0.0861728 7.3442 0 7.51669 0 7.71069V19.2882C0 19.59 0.215658 19.8487 0.495833 19.9134L6.1229 21.207C6.20907 21.2285 6.3169 21.2285 6.42472 21.207L11.9009 19.9567L17.377 21.2287C17.4202 21.2287 17.4632 21.2502 17.528 21.2502C17.679 21.2502 17.8083 21.207 17.9377 21.1208C18.0887 20.9915 18.1748 20.819 18.1748 20.6034V9.00428C18.1748 8.70245 17.9807 8.44377 17.6789 8.37897L17.679 8.37912ZM16.8814 19.7626L12.5479 18.7708V8.52996L16.8814 9.52178V19.7626Z",
    fill: "#004877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.82079 10.6427C5.99329 11.0092 6.53226 11.0092 6.70477 10.6427C6.70477 10.6427 8.79606 6.58951 9.27041 5.61932C9.74472 4.67066 9.76624 3.5712 9.27041 2.60105C8.42958 0.940923 6.40298 0.272613 4.74289 1.1134C3.08291 1.9327 2.43608 4.02403 3.25523 5.61936C4.07454 7.21481 5.82087 10.6428 5.82087 10.6428L5.82079 10.6427ZM6.27362 2.57942C7.1576 2.57942 7.86907 3.29088 7.86907 4.17487C7.86907 5.05885 7.1576 5.77032 6.27362 5.77032C5.38964 5.77032 4.67817 5.05885 4.67817 4.17487C4.67817 3.29073 5.38964 2.57942 6.27362 2.57942Z",
    fill: "#004877"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSvg2);
export default __webpack_public_path__ + "static/media/mapSvg2.0f50d7abf4247aba9b1a8f9acf10736e.svg";
export { ForwardRef as ReactComponent };